import { Expose } from "class-transformer";

export class UpdateBusinessUnitDto {
  @Expose()
  id: string;

  @Expose()
  name: string;
}
